import { Icona } from '../../components/Icona';
import type { Area, Vista } from '../../lib/menu';
import { areaDiVista, areeVisibili, primaVistaDellArea, vociDellArea } from '../../lib/menu';
import type { Sessione } from '../../lib/sessione';

/*  LA SCHERMATA DA CUI SI PARTE.

    Chiesta da Galizzi in riunione il 14/09/2026 e precisata da Andrea il 20/09: «subito
    dopo il login ci saranno delle icone tipo app che distingueranno le macroaree».

    Perché serve, al di là di com'è bella: il menu di prima metteva tredici schermate
    sulla stessa riga, tutte allo stesso livello, e non diceva niente su cosa c'entra con
    cosa. Chi apriva l'applicativo la prima volta doveva provare le voci per capire dove
    stessero le cose. Cinque riquadri con sotto una riga di spiegazione la stessa domanda
    la chiudono prima di farla nascere.

    Non è un menu con le icone: è il posto dove si torna. Dentro un'area il menu in alto
    mostra solo le voci di quell'area, e la voce «Home» riporta qui.
*/

export function Home({
  sessione,
  inCoda,
  onApri,
}: {
  sessione: Sessione;
  /** I rapportini compilati e non ancora arrivati in ufficio. */
  inCoda: number;
  onApri: (vista: Vista) => void;
}) {
  const aree = areeVisibili(sessione);
  const nome = sessione.nomeCompleto?.split(' ')[0] ?? null;

  /*  Il numero dei rapportini in coda si vede anche da qui. Nel menu c'era già, e con la
      pagina iniziale davanti sarebbe sparito proprio per chi serve: l'operaio che ha
      compilato in cantiere senza campo apre l'applicativo, vede il riquadro e deve sapere
      che c'è ancora qualcosa da mandare, senza entrare a controllare.  */
  const areaInCoda = areaDiVista('rapportino');

  return (
    <div className="avvio">
      <div className="testata-avvio">
        <h1>{nome ? `Ciao ${nome}` : 'TeraWorks'}</h1>
        <p>Da dove si comincia.</p>
      </div>

      <div className="macroaree">
        {aree.map((area) => (
          <Riquadro
            key={area.chiave}
            area={area}
            sessione={sessione}
            inCoda={area.chiave === areaInCoda ? inCoda : 0}
            onApri={onApri}
          />
        ))}
      </div>
    </div>
  );
}

function Riquadro({
  area,
  sessione,
  inCoda,
  onApri,
}: {
  area: Area;
  sessione: Sessione;
  inCoda: number;
  onApri: (vista: Vista) => void;
}) {
  const voci = vociDellArea(area.chiave, sessione);
  const dove = primaVistaDellArea(area.chiave, sessione);

  /*  Spento vuol dire spento: un `div` e non un `button` disabilitato, così non finisce
      nel giro dei tasti e chi naviga da tastiera non ci si ferma sopra per niente.  */
  if (dove === null) {
    return (
      <div className="macroarea spenta">
        <span className="disco">
          <Icona nome={area.chiave} />
        </span>
        <span className="nome">
          {area.etichetta}
          <em>in arrivo</em>
        </span>
        <span className="cosa">{area.cosa}</span>
      </div>
    );
  }

  return (
    <button type="button" className="macroarea" onClick={() => onApri(dove)}>
      <span className="disco">
        <Icona nome={area.chiave} />
        {inCoda > 0 && <em className="coda">{inCoda}</em>}
      </span>
      <span className="nome">{area.etichetta}</span>
      <span className="cosa">{area.cosa}</span>
      {/*  Le schermate dell'area, scritte sotto: dicono cosa c'è dentro prima di
           entrare, e a chi l'applicativo lo usa da mesi risparmiano il riquadro —
           sa già che «Bolle» sta in Acquisti e ci va dal menu.  */}
      <span className="dentro">{voci.map((v) => v.etichetta).join(' · ')}</span>
    </button>
  );
}
